import { useTranslate } from "@opensea/next-translate"
import { IconButton, UnstyledButton } from "@opensea/ui-kit"
import { Edit, Delete } from "@opensea/ui-kit/icons"
import React from "react"
import { Text } from "@/design-system/Text"

type Props = {
  icon: React.ReactNode
  label: string
  description: string
  enrolled: boolean
  canUnenroll: boolean
  onEdit?: () => void
  onUnenroll?: () => void
  onSetUp?: () => void
}

export function MfaMethodItem({
  icon,
  label,
  description,
  enrolled,
  canUnenroll,
  onEdit,
  onUnenroll,
  onSetUp,
}: Props) {
  const t = useTranslate("mfa")

  return (
    <div className="group relative flex w-full items-center justify-between rounded-lg bg-component-gray-1 p-3">
      <div className="flex items-center">
        <div className="mr-4 flex size-15 items-center justify-center rounded-md bg-component-gray-1">
          {icon}
        </div>
        <div>
          <Text asChild weight="semibold">
            <div>{label}</div>
          </Text>
          <Text.Body asChild size="small">
            <div>{description}</div>
          </Text.Body>
        </div>
      </div>
      {enrolled ? (
        <div className="hidden h-full items-center space-x-2 group-hover:flex">
          {onEdit ? (
            <IconButton onClick={onEdit}>
              <Edit />
            </IconButton>
          ) : null}
          {canUnenroll && onUnenroll ? (
            <IconButton onClick={onUnenroll}>
              <Delete />
            </IconButton>
          ) : null}
        </div>
      ) : (
        <UnstyledButton
          className="flex h-full items-center bg-transparent p-1 text-blue-3"
          onClick={onSetUp}
        >
          <Text.Body weight="semibold">
            {t("enrollmentItem.setUp", "Set up")}
          </Text.Body>
        </UnstyledButton>
      )}
    </div>
  )
}
